// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"445b4fadeed6f3c063b6","993":"2bbd6f168c66c75d5c96"}[chunkId] + ".js");